import React, { useState, useEffect, useContext } from "react";
import restService from "../../../restService";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import BarChart from "./barchart";
import PieChart from "./piechart";
import CampaignContext from "../../../contexts/CampaignContext";
import User from "../../../contexts/UserContext";
import Gender from "./gender";
import Age from "./age";
import Flavor from "./flavor";
import SKU from "./SKU";
import { addDays } from "date-fns";
import { DatePicker } from "../../components";

import exporting from "highcharts/modules/exporting";
import accessibility from "highcharts/modules/accessibility";

// Initialize exporting and accessibility modules
exporting(Highcharts);
accessibility(Highcharts);

const Insights = () => {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(User);
  const [data, setData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [ageGroupData, setAgeGroupData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [flavorData, setFlavorData] = useState([]);
  const [winPercentagePerBrandData, setWinPercentagePerBrandData] = useState(
    []
  );
  const [skuData, setSkuData] = useState([]);

  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
      endDate: new Date().setHours(23, 59, 59, 0),
      key: "selection",
    },
  ]);

  // useEffect(() => {
  //   console.log(
  //     new Date(state[0].startDate).toISOString().slice(0, 10),
  //     new Date(state[0].endDate).toISOString().slice(0, 10)
  //   );
  // }, [state]);

  useEffect(() => {
    // console.log("campaign", campaign);
    getDemographicDataSummary();
    handleGetBrandInsight();
  }, [state]);

  const getDemographicDataSummary = async () => {
    try {
      const {
        data: { data },
      } = await restService.Insights.getInsights(
        campaign.id,
        // "2022-06-30",
        // "2022-07-9"
        new Date(state[0].startDate).toISOString().slice(0, 10),
        new Date(state[0].endDate).toISOString().slice(0, 10)
      );

      if (Object.keys(data[0].gender).length > 0) {
        setGenderData([
          {
            name: "Male",
            y: data[0].gender.Male ? data[0].gender.Male : 0,
          },
          {
            name: "Female",
            y: data[0].gender.Female ? data[0].gender.Female : 0,
          },
        ]);
      }

      if (Object.keys(data[0].ageGroup).length > 0) {
        setAgeGroupData([
          {
            name: "18 - 24yrs",
            y: data[0].ageGroup["18 - 24yrs"]
              ? data[0].ageGroup["18 - 24yrs"]
              : 0,
          },
          {
            name: "25 - 34yrs",
            y: data[0].ageGroup["25 - 34yrs"]
              ? data[0].ageGroup["25 - 34yrs"]
              : 0,
          },
          {
            name: "35 - 44yrs",
            y: data[0].ageGroup["35 - 44yrs"]
              ? data[0].ageGroup["35 - 44yrs"]
              : 0,
          },
          {
            name: "45 - 54yrs",
            y: data[0].ageGroup["45 - 54yrs"]
              ? data[0].ageGroup["45 - 54yrs"]
              : 0,
          },
          {
            name: "55 - 64yrs",
            y: data[0].ageGroup["55 - 64yrs"]
              ? data[0].ageGroup["55 - 64yrs"]
              : 0,
          },
          {
            name: "65+",
            y: data[0].ageGroup["65+"] ? data[0].ageGroup["65+"] : 0,
          },
        ]);
      }

      if (Object.keys(data[0].flavours).length > 0) {
        setFlavorData([
          {
            name: "Strawberry",
            y: data[0].flavours.Strawberry ? data[0].flavours.Strawberry : 0,
          },
          {
            name: "Vanilla",
            y: data[0].flavours.Vanilla ? data[0].flavours.Vanilla : 0,
          },
          {
            name: "Chocolate",
            y: data[0].flavours.Chocolate ? data[0].flavours.Chocolate : 0,
          },

          {
            name: "Double Treat",
            y: data[0].flavours["Double Treat"]
              ? data[0].flavours["Double Treat"]
              : 0,
          },
        ]);
      }

      if (Object.keys(data[0].skus).length > 0) {
        setSkuData([
          {
            name: "250ml",
            y: data[0].skus["250ml"] ? data[0].skus["250ml"] : 0,
          },
          {
            name: "500ml",
            y: data[0].skus["500ml"] ? data[0].skus["500ml"] : 0,
          },

          {
            name: "1L",
            y: data[0].skus["1L"] ? data[0].skus["1L"] : 0,
          },
          {
            name: "2L",
            y: data[0].skus["2L"] ? data[0].skus["2L"] : 0,
          },
        ]);
      }

      if (Object.keys(data[0].region).length > 0) {
        setRegionData([
          {
            name: "Western Region",
            y: data[0].region["Western Region"]
              ? data[0].region["Western Region"]
              : 0,
          },
          {
            name: "Eastern Region",
            y: data[0].region["Eastern Region"]
              ? data[0].region["Eastern Region"]
              : 0,
          },
          {
            name: "Northern Region",
            y: data[0].region["Northern Region"]
              ? data[0].region["Northern Region"]
              : 0,
          },
          {
            name: "Volta Region",
            y: data[0].region["Volta Region"]
              ? data[0].region["Volta Region"]
              : 0,
          },
          {
            name: "Upper East Region",
            y: data[0].region["Upper East Region"]
              ? data[0].region["Upper East Region"]
              : 0,
          },
          {
            name: "Upper West Region",
            y: data[0].region["Upper West Region"]
              ? data[0].region["Upper West Region"]
              : 0,
          },
          {
            name: "Ashanti Region",
            y: data[0].region["Ashanti Region"]
              ? data[0].region["Ashanti Region"]
              : 0,
          },
          {
            name: "Central Region",
            y: data[0].region["Central Region"]
              ? data[0].region["Central Region"]
              : 0,
          },
          {
            name: "Greater Accra Region",
            y: data[0].region["Greater Accra Region"]
              ? data[0].region["Greater Accra Region"]
              : 0,
          },
          {
            name: "North-East Region",
            y: data[0].region["North-East Region"]
              ? data[0].region["North-East Region"]
              : 0,
          },
          {
            name: "Oti Region",
            y: data[0].region["Oti Region"] ? data[0].region["Oti Region"] : 0,
          },
          {
            name: "Ahafo Region",
            y: data[0].region["Ahafo Region"]
              ? data[0].region["Ahafo Region"]
              : 0,
          },
          {
            name: "Bono Region",
            y: data[0].region["Bono Region"]
              ? data[0].region["Bono Region"]
              : 0,
          },
          {
            name: "Savannah Region",
            y: data[0].region["Savannah Region"]
              ? data[0].region["Savannah Region"]
              : 0,
          },
          {
            name: "Bono East Region",
            y: data[0].region["Bono East Region"]
              ? data[0].region["Bono East Region"]
              : 0,
          },
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetBrandInsight = async () => {
    try {
      const {
        data: { data },
      } = await restService.Insights.getBrandsInsights(
        "63c538ef8650f62fd9e1779d",
        new Date(state[0].startDate).toISOString().slice(0, 10),
        new Date(state[0].endDate).toISOString().slice(0, 10)
      );

      const res = data.map((item) => {
        return {
          name: item.brand,
          y: item.report?.count?.global,
        };
      });

      setWinPercentagePerBrandData(res);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="h-full px-4 md:px-8 w-full mb-10">
      <h1 className=" text-[24px] leading-9 font-[600]">Insights</h1>
      <div className="flex flex-col gap-8 mt-8">
        <div className="bg-white shadow w-full py-4 px-8">
          <div className="flex justify-between w-full items-center mb-3 mt-2">
            <div>
              <p>Regions</p>
            </div>

            <DatePicker state={state} setState={setState} />
          </div>
          {/* Region */}

          <BarChart
            Highcharts={Highcharts}
            HighchartsReact={HighchartsReact}
            data={regionData}
          />
        </div>

        <div className="flex items-center gap-8   lg:flex-row flex-col justify-between">
          <div className="bg-white shadow w-full  ">
            {/* gender */}
            <Gender
              Highcharts={Highcharts}
              HighchartsReact={HighchartsReact}
              data={genderData}
              // title={"Gender"}
            />
          </div>
          <div className="bg-white shadow w-full">
            {/* age */}
            <Age
              Highcharts={Highcharts}
              HighchartsReact={HighchartsReact}
              data={ageGroupData}
              // title={"Age"}
            />
          </div>
        </div>

        <div className="flex items-start gap-8   lg:flex-row flex-col justify-between">
          <div className="bg-white shadow w-full  ">
            {/* flavor */}
            <Flavor
              Highcharts={Highcharts}
              HighchartsReact={HighchartsReact}
              data={winPercentagePerBrandData}
              // data={flavorData}
              // title={"Gender"}
            />
          </div>
          <div className="bg-white shadow w-full">
            {/* Size */}
            <SKU
              Highcharts={Highcharts}
              HighchartsReact={HighchartsReact}
              data={skuData}
              // title={"Age"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;
